var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.745 13.98C20.4472 12.9705 20.8712 11.7939 20.9741 10.5685C21.0771 9.34314 20.8554 8.11227 20.3315 6.9998C19.8075 5.88732 18.9998 4.9325 17.9895 4.23144C16.9792 3.53039 15.8021 3.10783 14.5766 3.00632C13.3511 2.9048 12.1205 3.12791 11.0086 3.65317C9.89678 4.17844 8.94291 4.98734 8.24304 5.99843C7.54318 7.00953 7.12201 8.18716 7.02194 9.41277C6.92187 10.6384 7.14642 11.8687 7.673 12.98",
    stroke: "#4776E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.97998C12.895 6.97998 12 7.65198 12 8.47998C12 9.30798 12.895 9.97998 14 9.97998C15.105 9.97998 16 10.652 16 11.48C16 12.308 15.105 12.98 14 12.98M14 6.97998C14.87 6.97998 15.612 7.39698 15.886 7.97998M14 6.97998V5.97998M14 12.98C13.13 12.98 12.388 12.563 12.114 11.98M14 12.98V13.98M3 14.98H5.395C5.689 14.98 5.979 15.046 6.242 15.174L8.284 16.162C8.547 16.289 8.837 16.355 9.132 16.355H10.174C11.182 16.355 12 17.146 12 18.122C12 18.162 11.973 18.196 11.934 18.207L9.393 18.91C8.93705 19.0359 8.45087 18.9919 8.025 18.786L5.842 17.73M12 17.48L16.593 16.069C16.9929 15.9463 17.4213 15.953 17.817 16.0883C18.2128 16.2235 18.5558 16.4803 18.797 16.822C19.166 17.332 19.016 18.064 18.478 18.374L10.963 22.711C10.728 22.8469 10.4678 22.9336 10.1982 22.9658C9.92866 22.9979 9.65537 22.9749 9.395 22.898L3 21",
    stroke: "#4776E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferEarn);
export default __webpack_public_path__ + "static/media/refer-earn.e610fce94b143ca781e613d3024dc758.svg";
export { ForwardRef as ReactComponent };